module.exports = __webpack_public_path__ + "static/media/16UNODC9.6b2c4c3a.jpg";